export const contactEditStyle = {
	wrapper: {
		marginTop: '40px',
		width: '100%',
	},
};
